export default "__VITE_ASSET__BbjnJWpf__"